// tslint:disable
export var PrescriberLicenseType;
(function (PrescriberLicenseType) {
    // UNKNOWN
    PrescriberLicenseType[PrescriberLicenseType["UNKNOWN"] = 0] = "UNKNOWN";
    // DRUG ENFORCEMENT ADMINISTRATION NUMBER
    PrescriberLicenseType[PrescriberLicenseType["DRUGENFORCEMENTADMINISTRATIONNUMBER"] = 1] = "DRUGENFORCEMENTADMINISTRATIONNUMBER";
    // STATE LICENSE ID
    PrescriberLicenseType[PrescriberLicenseType["STATELICENSEID"] = 2] = "STATELICENSEID";
    // MEDICAID ID
    PrescriberLicenseType[PrescriberLicenseType["MEDICAIDID"] = 3] = "MEDICAIDID";
})(PrescriberLicenseType || (PrescriberLicenseType = {}));
//# sourceMappingURL=PrescriberLicenseType.js.map